// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/gnss-safety-tips.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/gnss-safety-tips/gnss-characteristics.js';
import g1 from '../lessons/navigation/gnss-safety-tips/gnss-interference-reporting.js';
import g2 from '../lessons/navigation/gnss-safety-tips/gnss-safety-tips.js';
import g3 from '../lessons/navigation/gnss-safety-tips/gps-use-limits.js';

mount([g0, g1, g2, g3]);
